export const createShippingReviewPayloadForUpdate = (lotData, formData, reviewComplete) => {
  const objectsReviewed = formData.items.map((item) => {
    if (item.id.startsWith('new-object-')) delete item.id; // Remove id for new objects
    return item;
  });

  return {
    review: {
      originID: formData.originID,
      termsID: formData.termsID,
      objectsDescription: lotData.shippingReviewData?.arguments?.objectsDescription,
      objectsValue: lotData.shippingReviewData?.arguments?.objectsValue,
      objectsValueCurrency: lotData.shippingReviewData?.arguments?.objectsValueCurrency,
      objectsImages: lotData.shippingReviewData?.arguments?.objectsImages,
      objectsReviewed,
      reviewComplete,
    }
  };
};
